import { render, staticRenderFns } from "./patientName.vue?vue&type=template&id=08cb0ff8&scoped=true"
import script from "./patientName.vue?vue&type=script&lang=ts"
export * from "./patientName.vue?vue&type=script&lang=ts"
import style0 from "./patientName.vue?vue&type=style&index=0&id=08cb0ff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb0ff8",
  null
  
)

export default component.exports